/* src/app/components/controls/content-controls/sem-table-presentation/sem-table-presentation.component.css */
.table-presentation-empty,
.table-presentation-error {
  padding: 12px 0;
  opacity: .7;
}
.table-presentation-error {
  color: #b3261e;
  opacity: 1;
}
/*# sourceMappingURL=sem-table-presentation.component.css.map */
